import { useQuery } from '@apollo/client';
import { FIND_ALL_BCP_CORPORATES_METADATA } from '../pages/bcp/queries';
import { FETCH_LOCATION_METADATA_BY_ID } from '../pages/dataInputs/queries/locations';
import { useMemo } from 'react';

const useBCPMetaData = (locationId: string, isLocationType: boolean = true) => {
  const {
    data: locationMetadata,
    loading: locationMetadataLoading,
    error: locationMetadataError,
  } = useQuery(FETCH_LOCATION_METADATA_BY_ID, {
    variables: { uuid: locationId },
    skip: !isLocationType || !locationId,
  });

  const {
    data: corporateData,
    loading: corporateLoading,
    error: corporateError,
  } = useQuery(FIND_ALL_BCP_CORPORATES_METADATA, {
    skip: isLocationType || !locationId,
  });

  const locationMeta = locationMetadata?.findLocationByUuid || {};
  const corporateMeta = corporateData?.findAllBcpCorporates?.[0] || {};

  const result = useMemo(() => {
    if (isLocationType) {
      return {
        planUUID: locationMeta.planUUID,
        locationName: locationMeta.locationName,
        lastBcpUpdate: locationMeta.lastBcpUpdate,
        loading: locationMetadataLoading,
        error: locationMetadataError,
      };
    } else {
      return {
        planUUID: corporateMeta.planUUID,
        lastBcpUpdate: corporateMeta.lastBcpUpdate,
        loading: corporateLoading,
        error: corporateError,
      };
    }
  }, [
    isLocationType,
    locationMeta.planUUID,
    locationMeta.locationName,
    locationMeta.lastBcpUpdate,
    locationMetadataLoading,
    locationMetadataError,
    corporateMeta.planUUID,
    corporateMeta.lastBcpUpdate,
    corporateLoading,
    corporateError,
  ]);

  return result;
};

export default useBCPMetaData;
